export class FilterOptionListNotFoundError extends Error {
  constructor(optionValue: string) {
    super(`Option with value "${optionValue}" do not exists in option list.`);

    this.name = 'FilterOptionListNotFoundError';
  }
}
